"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptionsList = void 0;
require("@veeam/components");
const getOptionsList = (list) => {
    return list.map((item) => ({
        id: item,
        name: item,
    }));
};
exports.getOptionsList = getOptionsList;
//# sourceMappingURL=getOptionsList.js.map